var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.48 7H11.52C8.07 7 6 9.06 6 12.52V20.47C6 23.94 8.07 26 11.52 26H19.47C22.93 26 24.99 23.94 24.99 20.48V12.52C25 9.06 22.93 7 19.48 7Z",
    fill: "#0095DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.02 6.98003C23.23 5.18003 21.48 5.14003 19.64 6.98003L18.51 8.10003C18.41 8.20003 18.38 8.34003 18.42 8.47003C19.12 10.92 21.08 12.88 23.53 13.58C23.56 13.59 23.61 13.59 23.64 13.59C23.74 13.59 23.84 13.55 23.91 13.48L25.02 12.36C25.93 11.45 26.38 10.58 26.38 9.69003C26.38 8.79003 25.93 7.90003 25.02 6.98003Z",
    fill: "#0095DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.86 14.42C21.59 14.29 21.33 14.16 21.09 14.01C20.89 13.89 20.69 13.76 20.5 13.62C20.34 13.52 20.16 13.37 19.98 13.22C19.96 13.21 19.9 13.16 19.82 13.08C19.51 12.83 19.18 12.49 18.87 12.12C18.85 12.1 18.79 12.04 18.74 11.95C18.64 11.84 18.49 11.65 18.36 11.44C18.25 11.3 18.12 11.1 18 10.89C17.85 10.64 17.72 10.39 17.6 10.13C17.47 9.84997 17.37 9.58997 17.28 9.33997L11.9 14.72C11.55 15.07 11.21 15.73 11.14 16.22L10.71 19.2C10.62 19.83 10.79 20.42 11.18 20.81C11.51 21.14 11.96 21.31 12.46 21.31C12.57 21.31 12.68 21.3 12.79 21.29L15.76 20.87C16.25 20.8 16.91 20.47 17.26 20.11L22.64 14.73C22.39 14.65 22.14 14.54 21.86 14.42Z",
    fill: "#0095DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.6bf25d633648982b4ca61de53b97aef9.svg";
export { ForwardRef as ReactComponent };